import React, { useState, useEffect, useCallback } from 'react';
import { Dropdown } from '@kufox/mui';
import { UpOutlined, DownOutlined } from '@kufox/icons';
import { styled } from '@kufox/mui/emotion';
import Overlay from './OverLay';
import { isForbiddenCountry } from '../../common/tools';

const Text = styled.div`
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`;

/**
 *
 * @param {*} checkForbidden  被禁止的国家，国旗/区号不显示， 国家名称显示为其他
 * @param dropForbidden 被禁止的国家, 直接不显示
 * @returns
 */
function PhoneAreaSelector({
  countries,
  isCn,
  onChange,
  value,
  language,
  useInit,
  checkForbidden,
  dropForbidden,
}) {
  const [param, setValue] = useState(value);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (useInit) {
      // 使用初始值，不自动匹配
      return;
    }
    const getParam = () => {
      const langCode = language ? language.split('_')[1] : 'US';
      // 葡萄牙语，则默认展示+55（巴西区号，我们不支持葡萄牙注册）
      if (langCode === 'PT') {
        return '55';
      }
      // dropForbidden = true, 且langcode为屏蔽的国家，则默认显示 '1'
      if (dropForbidden && isForbiddenCountry(langCode, 'code')) {
        return '1';
      }
      const curCountry = countries.find((c) => c.code === langCode);
      if (countries && curCountry) {
        return curCountry.mobileCode;
      }
      return '1';
    };
    const defaultParam = getParam();
    setValue(defaultParam);
    onChange(defaultParam);
  }, [language, countries.length, dropForbidden]);

  const handleClick = (code) => {
    setValue(code);
    setVisible(false);
    onChange(code);
  };

  const getIsForbidden = useCallback(
    (code) => {
      const forbiddenItem = isForbiddenCountry(code);
      const isForbidden = checkForbidden && forbiddenItem;
      return isForbidden ? forbiddenItem : false;
    },
    [checkForbidden],
  );

  const getDispayCode = (code) => {
    const isForbidden = getIsForbidden(code);
    let displayCode = '';
    if (isForbidden) {
      displayCode = isCn ? isForbidden.aliasName : isForbidden.aliasNameEN;
    }
    return isForbidden ? `${displayCode}` : `+${code}`;
  };

  return (
    <Dropdown
      visible={visible}
      trigger="click"
      overlay={
        <Overlay
          data={countries}
          isCn={isCn}
          onClickCode={handleClick}
          checkForbidden={checkForbidden}
          dropForbidden={dropForbidden}
        />
      }
      onVisibleChange={(v) => setVisible(v)}
    >
      <Text>
        <span style={{ fontSize: getIsForbidden(param) ? '14px' : '16px' }}>
          {getDispayCode(param)}
        </span>
        {visible ? <UpOutlined size={24} /> : <DownOutlined size={24} />}
      </Text>
    </Dropdown>
  );
}

export default PhoneAreaSelector;
